/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from "react";
import { getEdgeCenter } from "react-flow-renderer";

import { getSmoothStepPath, getMarkerEnd } from "reactflow";

import "./Style.scss";
import EdgeAddButton from "../EdgeAddButton/EdgeAddButton";

const [buttonWidth, buttonHeight] = [100, 40];

export const Condition = (props) => {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    arrowHeadType,
    markerEndId,
    data,
  } = props;
  const [path, labelX, labelY] = getSmoothStepPath({
    // getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);

  getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <path
        id={id}
        d={path}
        markerEnd={markerEnd}
        className="react-flow__edge-path"
      />

      <foreignObject
        width={buttonWidth}
        height={buttonHeight}
        x={labelX - buttonWidth / 2}
        y={labelY - buttonHeight / 2}
        requiredExtensions="http://www.w3.org/1999/xhtml"
      >
        <EdgeAddButton
          {...props}
          style={{ width: buttonWidth, height: buttonHeight }}
        />
      </foreignObject>
    </>
  );
};
